export default __webpack_public_path__ + "static/media/locationmap.040eb2e2.svg";